import { render, staticRenderFns } from "./FilemanagerDeleteConfirm.vue?vue&type=template&id=648d94da&"
import script from "./FilemanagerDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./FilemanagerDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports